import striptags from 'striptags';

export const StripHtmlFilterModule = angular
    .module('app.filters.stripHtmlFilter', [])
    .filter('stripHTML', () => {
        return (value, allowedTags = []) => {
            value = (value === undefined || value === null) ? '' : value;

            return striptags(value, allowedTags.join(''));
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/filters/stripHtml.filter.js